import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {AnimationContents} from "../AnimationContents";
import {GameLogic} from "../../Logic/GameLogic";
import { PlayerTurnConstant } from "../../Constants/PlayerTurnConstant";
import {LocalizationContents} from "../../LocalizationContents";
export interface IIntroScreenControllerOptions {
}

export class MiniGameScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("MiniGameScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.WIN_WINDOW_SCREEN_JSON,
            libraryName: "win_container",
            childControllers: {},
            modelWatch: {}
        };
    }

    determiningWinner(): number {
        let rand = 0 - 0.5 + Math.random() * (1 - 0 + 1);
        return Math.round(rand);
    }

    protected onInitialize(): void {
        this.setTextByQuery("txt1.catch_bat", LocalizationContents.catch_bat);
        this.setTextByQuery("txt2.catch_bat_success", LocalizationContents.catch_bat_success);
        this.setTextByQuery("txt3.catch_bat_fail", LocalizationContents.catch_bat_fail);
        let result = "success";
        if (this.determiningWinner()) {
            this._gameLogic.setPlayerTurn(PlayerTurnConstant.A);
        } else {
            result = "failure";
            this._gameLogic.setPlayerTurn(PlayerTurnConstant.B);
        }
        this.gotoAndPlay(result);

    }

    protected onAnimationEvent(name:string, ...args)
    {
        if(name === "finishMiniGame"){
            this._gameLogic.hidenModal();
            this._gameLogic.startNewGame();
            this._gameLogic.hideMiniGame();
            this._gameLogic.play();
            this._gameLogic.hideMainMenuContainer();
        }
        if(!this.$model.tutorialWasShow){
            this._gameLogic.help();
        }
    }


    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

